/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Version } from '@angular/core';
/**
 * Current version of Angular Material.
 */
export var VERSION = new Version('0.0.0-PLACEHOLDER');
//# sourceMappingURL=version.js.map